import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import ChartTooltip from "./ChartTooltip";

export function Donut({ data, cx="50%", cy="50%", ir=54, or=76, center, height=162, onClickSlice, onSegmentClick }) {
  const handler = onSegmentClick || onClickSlice;
  return (
    <div className="relative">
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie data={data} cx={cx} cy={cy} innerRadius={ir} outerRadius={or} dataKey="value" paddingAngle={2} cornerRadius={3}
            onClick={handler ? (d) => handler(d) : undefined}
            className={handler ? "cursor-pointer" : "cursor-default"}>
            {data.map((d,i) => <Cell key={i} fill={d.color}/>)}
          </Pie>
          <Tooltip content={<ChartTooltip/>}/>
        </PieChart>
      </ResponsiveContainer>

      {center && (
        <div className="absolute text-center pointer-events-none leading-[1.3] -translate-x-1/2 -translate-y-1/2" style={{ top:cy, left:cx }}>
          <div className="text-xl font-extrabold" style={{ color:center.color||"#1E293B" }}>{center.val}</div>
          <div className="text-[9px] text-[#94A3B8] mt-[3px]">{center.lbl}</div>
        </div>
      )}
    </div>
  );
}

export function Leg({ data, onClickItem }) {
  return (
    <div className="flex flex-wrap gap-x-[14px] gap-y-[5px] justify-center mt-2.5">
      {data.map(d => (
        <span
          key={d.name}
          onClick={() => onClickItem && onClickItem(d.name)}
          className={`flex items-center gap-[5px] text-[10.5px] text-[#64748B] px-1 py-0.5 rounded-[5px] transition-colors duration-150 ${
            onClickItem ? "cursor-pointer hover:bg-[#F1F5F9]" : "cursor-default"
          }`}
        >
          <span className="w-2 h-2 rounded-full shrink-0" style={{ background:d.color }}/>{d.name} <strong className="text-[#1E293B]">{d.value.toLocaleString()}</strong>
        </span>
      ))}
    </div>
  );
}

export function MiniLeg({ items }) {
  return (
    <div className="flex gap-[14px] flex-wrap mb-2.5">
      {items.map(({c,l}) => (
        <span key={l} className="flex items-center gap-[5px] text-[10.5px] text-[#64748B]">
          <span className="w-2 h-2 rounded-[3px] shrink-0" style={{ background:c }}/>{l}
        </span>
      ))}
    </div>
  );
}